<template>
  <div>
    <div v-if="data.chapters.length === 1">
      <topic-wrapper>
        <topic-regular
          :data="data.chapters[0]"
          :has-enrolled="true"
          v-toggle-collapse="`accordion-${data.chapters[0].id}`"
          role="tab"
        />
        <b-collapse-kariermu
          :id="`accordion-${data.chapters[0].id}`"
          role="tabpanel"
          :visible="true"
        >
          <activity
            v-for="(activity, activityIndex) in tourData.activityData"
            :number="setNumbering(topicIndex, activityIndex)"
            :is-linier="isLinier"
            :data="activity"
            :key="activity.id"
            :is-active="activity.id === 1"
          />
        </b-collapse-kariermu>
      </topic-wrapper>
    </div>
  </div>
</template>
<script>
import TopicWrapper from '@/components/activityV2/Sidebar/TopicWrapper'
import TopicRegular from '@/components/activityV2/Sidebar/TopicRegular'
import Activity from '@/components/activityV2/Sidebar/Activity'
import activityV2GeneralMixin from '@/mixins/activityV2/general'
import activityV2SidebarTabActivityMixin from '@/mixins/activityV2/sidebarTabActivity'

export default {
  name: 'TabActivitySectionTourTopic',
  mixins: [activityV2GeneralMixin, activityV2SidebarTabActivityMixin],
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    topicIndex: {
      type: Number,
      default: 0
    },
    isLinier: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TopicWrapper,
    TopicRegular,
    Activity
  }
}
</script>
